import React, {useEffect, useState} from 'react';

import styles from './SearchCar.module.css';
import {SelectFiltered} from "../../ui/SelectFiltered/SelectFiltered.tsx";
import {useScreenDetector} from "../../hooks/useScreenDetector.ts";
import {TemplateType} from "./types/TemplateTypeEnum.ts";
import {cn} from "../../utils/cn.ts";
import {SelectOption} from "../../ui/SelectFiltered/types/SelectOption.interface.ts";
import {Select} from "../../ui/DataEntry/Select/Select.tsx";
import {Button} from "../../ui/General/Button/Button.tsx";
import { API_URL } from '../../config.tsx';

interface Props {
}

interface Brands {
    brandCode?: string,
    getCatalog: (catalogs: {[key in number]: {name: string, options: SelectOption[]}}, brandCode: string, ssd: string, step: number) => void,
    catalogs: {[key in number]: {name: string, options: SelectOption[]}},
}

const SelectBrands: React.FC<Brands> = ({getCatalog, catalogs, brandCode}) => {
    const [brand, changeBrand] = useState('');
    const [brands, setBrands] = useState([]);

    const getBrands = (brandCode?: string) => {
        fetch(`${API_URL}/car_brands`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(brands => {
                setBrands(brands)
                if(brandCode) {
                    brands.map((brand: {id: string, value: string}) => {
                        if (brand.value.toLowerCase() === brandCode.toLowerCase()) {
                            changeBrand(brand.value);
                            getCatalog(catalogs, brand.id, '', 1);
                        }
                    })
                }
            })
    }

    const onChangeBrand = (brandName: React.SetStateAction<string>) => {
        brands.map((brand: {id: string, value: string}) => {
            if (brand.value == brandName) {
                changeBrand(brand.value);
                getCatalog(catalogs, brand.id, '', 1);
            }
        })
    }

    useEffect(() => {
        getBrands(brandCode);
    }, [brandCode]);

    return <SelectFiltered
        rootClassName={styles.selectInput}
        options={brands}
        placeholder='Выберите марку'
        value={brand ?? ''}
        onChange={onChangeBrand}
    />
}

interface Props {
    template?: TemplateType
    title?: string,
    brand?: string,
    modelSlug?: string,
    bodySlug?: string,
}

export const SearchCar: React.FC<Props> = ({template = TemplateType.first, brand, modelSlug, bodySlug}) => {
    const {isMobile, isDesktop} = useScreenDetector();

    const [brandCode, setBrandCode] = useState<string>('');
    const [ssd, setSsd] = useState<string>('');
    const [step, setStep] = useState<number>(0);
    const [stepValues, setStepValues] = useState<{[key in number]: string}>({});
    const [catalogs, setCatalogs] = useState<{[key in number]: {name: string, options: SelectOption[]}}>({});


    const search = () => {
        if (typeof window !== 'undefined') {
            window.open(`/search-vehicles?brand=${brandCode}&catalogSsd=${ssd}`)
        }
    }

    const getCatalog = (catalogs: {[key in number]: {name: string, options: SelectOption[]}}, brandCode: string, ssd: string, step: number) => {
        if(!brandCode) return;
        setBrandCode(brandCode);

        fetch(`${API_URL}/car_params?brandCode=${brandCode}&ssd=${ssd}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(catalog => {
                if(Object.keys(catalog).length === 0) return;
                let newCatalogs = [];
                let models: SelectOption[] = [];
                let bodies: SelectOption[] = [];
                Object.keys(catalogs).map(key => {
                    const stepKey = Number(key);
                    if (stepKey < step) newCatalogs[stepKey] = catalogs[stepKey];
                })
                if(step === 1) {
                    catalog.options.map((option: SelectOption) => {
                        models.push(option);
                    })
                }
                if(step === 2) {
                    catalog.options.map((option: SelectOption) => {
                        bodies.push(option);
                    })
                }
                newCatalogs[step] = catalog;
                setCatalogs(newCatalogs);
                if (catalog.options && catalog.options.length) setStep(step);
                if(modelSlug && step === 1) {
                    models.map(model => {
                        if(
                            model.value.toLowerCase() === modelSlug.toLowerCase()
                            || model.value.toLowerCase() === modelSlug.replace(' ', '').toLowerCase()
                            || model.value.toLowerCase() === modelSlug.replace('_', '').toLowerCase()
                            || model.value.toLowerCase() === modelSlug.replace('_', ' ').toLowerCase()
                            || model.value.toLowerCase() === modelSlug.replace(' ', '_').toLowerCase()
                        ) {
                            onChangeValue(newCatalogs,model.value, models, step + 1);
                            setStepValues({...stepValues, [step]: model.value});
                            return
                        }
                    })
                }
                if(bodySlug && step === 2) {
                    bodies.map(body => {
                        if(
                            body.value.toLowerCase() === bodySlug.toLowerCase()
                            || body.value.toLowerCase() === bodySlug.replace(' ', '').toLowerCase()
                            || body.value.toLowerCase() === bodySlug.replace('_', '').toLowerCase()
                            || body.value.toLowerCase() === bodySlug.replace('_', ' ').toLowerCase()
                            || body.value.toLowerCase() === bodySlug.replace(' ', '_').toLowerCase()
                        ) {
                            onChangeValue(newCatalogs, body.value, bodies, step + 1);
                            setStepValues({...stepValues, [step]: body.value});
                            return;
                        }
                    })
                }
            })
    }

    const onChangeValue = (catalogs: {[key in number]: {name: string, options: SelectOption[]}}, catalogValue: string, options: SelectOption[], step: number) => {
        let ssdValue = '';

        options.map(option => {
            if(
                option.value.toLowerCase() === catalogValue.toLowerCase()
                || option.value.toLowerCase() === catalogValue.replace(' ', '').toLowerCase()
                || option.value.toLowerCase() === catalogValue.replace('_', '').toLowerCase()
                || option.value.toLowerCase() === catalogValue.replace('_', ' ').toLowerCase()
                || option.value.toLowerCase() === catalogValue.replace(' ', '_').toLowerCase()
            ) ssdValue = String(option.id);
        });
        getCatalog(catalogs, brandCode, ssdValue, step);
        setSsd(ssdValue);
    }


    return (
        <div className={styles.container}>
            {
                isDesktop
                    ?
                    (TemplateType.second === template
                            ?
                            <div className={styles.second}>
                                <ol className={styles.inputs}>
                                    <li className={styles.item}>
                                    <span
                                        className={cn(styles.number)}>1</span>
                                        <SelectBrands getCatalog={getCatalog} brandCode={brand} catalogs={catalogs} />
                                    </li>
                                    {
                                        Object.keys(catalogs).map(key => {
                                            const stepKey = Number(key);
                                            return (
                                                <li className={styles.item}>
                                                    <span className={cn(styles.number, step !== stepKey && styles.numberActive)}>{stepKey + 1}</span>
                                                    <Select
                                                        selectClassName={cn(step === stepKey && styles.inputActive)}
                                                        rootClassName={cn(styles.selectInput, styles.input)}
                                                        options={catalogs[stepKey].options}
                                                        placeholder={catalogs[stepKey].name}
                                                        value={stepValues[stepKey] ? stepValues[stepKey] : ''}
                                                        onChange={(value) => setStepValues({...stepValues, [stepKey]: value})}
                                                        isLoading={false}
                                                        onSelect={(value) => onChangeValue(catalogs, value, catalogs[stepKey].options, stepKey + 1)}
                                                        onSelectOption={() => {
                                                        }}
                                                    />
                                                </li>
                                        )
                                        })
                                    }
                                    {step > 2 ? <Button className={styles.searchBtn} type='regular' id='search-car-btn' onClick={() => search()}>Поиск</Button> : null}
                                </ol>
                            </div>
                            :
                            <>
                                <div className={styles.inputs}>
                                    <SelectBrands getCatalog={getCatalog} brandCode={brand} catalogs={catalogs} />
                                    {
                                        Object.keys(catalogs).map(key => {
                                            const stepKey = Number(key);
                                            if(Object.keys(catalogs[stepKey]).length)
                                                return (
                                                    <SelectFiltered
                                                        rootClassName={stepKey === step && step > 1 ? cn(styles.selectInput, styles.selectInputLastChild) : styles.selectInput}
                                                        options={catalogs[stepKey].options}
                                                        placeholder={catalogs[stepKey].name}
                                                        value={''}
                                                        onChange={(value) => onChangeValue(catalogs, value, catalogs[stepKey].options, stepKey + 1)}
                                                    />
                                                )
                                        })
                                    }
                                </div>
                                {step > 1 ? <Button onClick={() => search()} className={styles.btn} type='search' id='search-car-btn'/> : null}
                            </>
                    )
                    : null
            }

            {isMobile && (<>
                <div>
                    <div className={styles.inputs}>
                        <h2 className={styles.title}>Подбор по марке/модели авто</h2>
                        <SelectBrands getCatalog={getCatalog} brandCode={brand} catalogs={catalogs} />
                        {
                            Object.keys(catalogs).map(key => {
                                const stepKey = Number(key);
                                if(Object.keys(catalogs[stepKey]).length)
                                    return (
                                        <SelectFiltered
                                            rootClassName={stepKey === step && step > 1 ? cn(styles.selectInput, styles.selectInputLastChild) : styles.selectInput}
                                            options={catalogs[stepKey].options}
                                            placeholder={catalogs[stepKey].name}
                                            value={''}
                                            onChange={(value) => onChangeValue(catalogs, value, catalogs[stepKey].options, stepKey + 1)}
                                        />
                                    )
                            })
                        }
                    </div>
                </div>
                {step > 1 ? <Button onClick={() => search()} className={styles.btn} type='search'/> : null}
            </>)}
        </div>
    );
};
